import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import chartjsMixin from '@/agilis/components/Chart/Chartjs/mixin/chartjsMixin'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)
export default {
  name: 'ChartjsLine',
  components: {
    LineChartGenerator
  },
  mixins: [chartjsMixin],
  props: {
    items: {
      type: [Object, Array]
    }
  },
  computed: {
    chartData () {
      const items = this.items
      const columns = Object.values(this.dashboardMetric.detail.dataTable.columns)
      const labelColConfig = columns[0]
      const valueColConfig = columns[1]
      const chart = {
        labels: [],
        datasets: [{
          backgroundColor: [],
          data: []
        }]
      }
      if (items) {
        items.forEach(item => {
          chart.labels.push(this.renderColumn(labelColConfig, item))
          chart.datasets[0].data.push(this.renderColumn(valueColConfig, item))
        })
        const dataLength = chart.datasets[0].data.length
        const backgroundColorsLength = this.dashboardMetric?.option?.backgroundColors.length
        let backgroundColors = this.dashboardMetric?.option?.backgroundColors
        if (backgroundColorsLength !== dataLength) {
          chart.datasets[0].backgroundColor = backgroundColors.concat(this.addColors(dataLength - backgroundColorsLength))
        } else {
          chart.datasets[0].backgroundColor = this.dashboardMetric?.option?.backgroundColors
        }
      }
      chart.datasets[0].label = this.$t(this.dashboardMetric.option.label)
      return chart
    }
  }
}
